import {
  RESUME_DATA_REQUEST,
  RESUME_DATA_SUCCESS,
  RESUME_DATA_FAILURE,
} from "../../actionTypes";

export const resumeDataRequest = (type) => ({
  type: RESUME_DATA_REQUEST,
  payload: type,
});

export const resumeDataSuccess = (data) => ({
  type: RESUME_DATA_SUCCESS,
  payload: data,
});

export const resumeDataFailure = (error) => ({
  type: RESUME_DATA_FAILURE,
  payload: error,
});
